import { useParams } from "react-router-dom"
import { ScheduledRuns } from "../components/scheduled/scheduledRuns"
import { UserbotPage } from "./userbotPage"

export const ScheduledRunsPage = () => {
  const { id } = useParams<{ id: string }>()
  return (
    <UserbotPage title="История запусков расписания">
      {id && <ScheduledRuns scheduleId={id} />}
    </UserbotPage>
  )
}
